import React from 'react';
import VertragsStudio from './contracts/VertragsStudio';

export const STANDARD_DOCUMENT_TEMPLATES = [
  {
    key: 'standarddoc-grundbuchauszug',
    label: 'Anschreiben Grundbuchauszug',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anschreiben_Grundbuchauszug_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-bauunterlagen',
    label: 'Anschreiben Bauunterlagen',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anschreiben_Bauunterlagen_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-grundbucheintragung',
    label: 'Anschreiben Grundbucheintragung',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anschreiben_Grundbucheintragung_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-st',
    label: 'Anfrage Verfahrensfreiheit (Sachsen-Anhalt)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_ST_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-by',
    label: 'Anfrage Verfahrensfreiheit (Bayern)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_BY_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-bw',
    label: 'Anfrage Verfahrensfreiheit (Baden-Württemberg)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_BW_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-ni',
    label: 'Anfrage Verfahrensfreiheit (Niedersachsen)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_NI_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-nrw',
    label: 'Anfrage Verfahrensfreiheit (Nordrhein-Westfalen)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_NRW_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-sl',
    label: 'Anfrage Verfahrensfreiheit (Saarland)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_SL_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-sh',
    label: 'Anfrage Verfahrensfreiheit (Schleswig-Holstein)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_SH_ENPOWER_CI.html' },
    ],
  },
  {
    key: 'standarddoc-verfahrensfreiheit-th',
    label: 'Anfrage Verfahrensfreiheit (Thüringen)',
    variants: [
      { key: 'ci', label: 'CI', file: 'Anfrage_Verfahrensfreiheit_TH_ENPOWER_CI.html' },
    ],
  },
];

export default function StandardDocumentsTemplateStudio({ apiBase = '/api', session = null }) {
  return (
    <VertragsStudio
      apiBase={apiBase}
      session={session}
      documents={STANDARD_DOCUMENT_TEMPLATES}
      basePath="/standard-documents/"
      typeLabel="Dokumentart"
      recordLabel="Dokumentenstand"
      originalButtonLabel="Original"
      mergeOriginalMissingSections={false}
      enableSiblingSync={false}
      enablePaymentSync={false}
      enableExampleClauses
      editorScope="standard-document-template"
    />
  );
}
